module.exports = __webpack_public_path__ + "ubuntu-regular-webfont.3eae4aa0d03ccfd44a50.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-regular-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-regular-webfont.woff2
// module chunks = styles